import { Button as ButtonAntD } from 'antd';
import styled from 'styled-components';

export const Button = styled(ButtonAntD)`
  height: 50px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 3px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous) {
    &:hover {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const MessageBox = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;

export const Label = styled.div`
  color: #7f7f7f;
  margin-bottom: 2px;
  font-weight: 300;
  font-size: 15px;
`;

export const RadioOption = styled.span`
  font-weight: 300;
  font-size: 16px;
`;

export const BadgeContainer = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  margin-right: 8px;
  align-items: center;
  justify-content: center;
  background-color: #515151;
  color: #fff;
  border-radius: 50%;
`;

export const SelectUsersErrorLabel = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;

export const SwitchWrapper = styled.div`
  height: 10px;
  display: flex;
  align-items: center;
`;
